<template>
    <section class="banner">
        <div class="-wrap">
            <div class="banner__container">
                <slot />
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            image: String
        }
    }
</script>

<style lang="scss" scoped>
    .banner {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        background-color: $light_blue;
        position: relative;

        [class*="desktop"] & {
            min-height: 300px;
        }

        &__container {
            background: $white;
            border-radius: 20px;
            margin: 40px auto;
        }
    }
</style>
